import { Component, computed, effect, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MockTestSecurityService } from '../../../core/security/mock-test-security.service';
import {
  SecurityViolationType,
  TERMINATION_MESSAGE,
  VIOLATION_MESSAGES,
} from '../../../core/security/mock-test-security.model';
import { ImageEnum } from '../../utils/image.enum';
import { PrimaryButtonComponent } from '../primary-button/primary-button';

@Component({
  selector: 'app-security-lock-overlay',
  imports: [PrimaryButtonComponent],
  templateUrl: './security-lock-overlay.html',
})
export class SecurityLockOverlayComponent {
  private readonly securityService = inject(MockTestSecurityService);
  private readonly router = inject(Router);

  protected readonly imageEnum = ImageEnum;
  protected readonly lockState = this.securityService.lockState;
  protected readonly resumeBlocked = signal(false);
  protected readonly isTerminal = computed(() => this.lockState().terminal === true);
  protected readonly message = computed(() => {
    if (this.isTerminal()) {
      return TERMINATION_MESSAGE;
    }

    const violation = this.lockState().violation;
    return violation ? VIOLATION_MESSAGES[violation] : '';
  });

  constructor() {
    effect(() => {
      if (!this.lockState().active) {
        this.resumeBlocked.set(false);
      }
    });
  }

  protected resume(): void {
    // Browsers don't let pages close devtools, so the lock stays until the
    // candidate closes them; the background poll then clears it automatically.
    const violation = this.lockState().violation;
    const isDevtoolsLock =
      violation === SecurityViolationType.DEVTOOLS_DETECTED || violation === SecurityViolationType.DEVTOOLS_SHORTCUT;
    if (isDevtoolsLock && this.securityService.isDevtoolsOpen()) {
      this.resumeBlocked.set(true);
      return;
    }

    this.resumeBlocked.set(false);
    this.securityService.resolveLock();
  }

  protected exitToTestSeries(): void {
    this.securityService.resolveLock();
    void this.router.navigate(['/test-series']);
  }
}
